import { UPDATE_SEARCHTDATA_THUDELETE } from "../../actions/DanhSachThuDelete/actionTypes";

const initialState = {
  name: "",
  NguoiXoa: "",
  dateFrom: "01/01/2001",
  dateTo: "01/01/4000",
  page: 1,
  pageSize: 25,
};

const updateDataSearch = (state, action) => ({
  ...action.payload,

  //matentaisan: action.payload.matentaisan,
  //searchText: action.payload,
});

export const dataSearchThuDelete = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_SEARCHTDATA_THUDELETE:
      return updateDataSearch(state, action);
    default:
      return state;
  }
};

export default dataSearchThuDelete;
